import { ComponentType } from 'react';
import { ApolloProvider } from '@apollo/client';

import { client } from '../client';

export default function apolloWrapper<T>(Component: ComponentType<T>) {
  // This is temporary hoc for wrapping components in apollo provider. In
  // future when we move to `spa` we will have only one ApolloProvider per
  // page.
  const wrapper = (props: T & JSX.IntrinsicAttributes) => (
    <ApolloProvider client={client}>
      <Component {...props} />
    </ApolloProvider>
  );

  return wrapper;
}
